/**
 * Delays for the widget's polite screen reader announcements.
 *
 * The two live regions (search suggestions and the question list summary) are
 * fed from the same search response, so they must not expire in the same tick -
 * a screen reader would queue both utterances back to back. The list summary is
 * announced first because it answers the action; the suggestion list, which is
 * the longer text, follows.
 */
export const LIST_ANNOUNCEMENT_DELAY = 700;

/**
 * Delay before available search suggestions are announced. Long enough that a
 * typed word does not produce one announcement per character.
 */
export const SUGGESTION_ANNOUNCEMENT_DELAY = 1200;

/**
 * Gap between clearing the list summary region and writing the new text.
 * A polite live region does not re-announce text identical to what it already
 * holds, so the region has to go empty for one paint in between.
 */
export const STATUS_RESET_GAP = 120;
